import { render } from "./QuizQuestion.vue?vue&type=template&id=2386f2ef&scoped=true&ts=true"
import script from "./QuizQuestion.vue?vue&type=script&lang=ts"
export * from "./QuizQuestion.vue?vue&type=script&lang=ts"

import "./QuizQuestion.vue?vue&type=style&index=0&id=2386f2ef&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2386f2ef"]])

export default __exports__